module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Hanger-3f21f9bd3b302ee1673ece5a1c3507a4.svg";